import React from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';

const PaymentConditionsInfo = props => {
  const { paymentConditions, paymentConditionsConfirmed, togglePaymentConditions } = props;
  return (
    <div
      style={{display: 'flex', flexDirection: 'column', position: 'relative'}}
    >
      <div>
        <RaisedButton
          label='ОК'
          onClick={
            () => {
              togglePaymentConditions('');
            }
          }
        />
      </div>
      <div style={{fontSize: '16px', marginTop: '12px', fontWeight: 'bold'}}>
        Запрощенные условия оплаты
      </div>
      <div style={{marginTop: '12px'}}>
        {
          paymentConditions.map((condition, i) => {
            if (condition.percent === 0)
              return null;
            return (
              <div key={i} style={{display: 'flex'}}>
                <div style={{flex: '0 0 60px'}}>{`${condition.percent}%`}</div>
                {
                  condition.type === 'days'
                  ?
                    <div style={{flex: '0 0 300px'}}>{`через ${condition.val} дней после отгрузки`}</div>
                  :
                  <div style={{flex: '0 0 300px'}}>{condition.val}</div>
                }
              </div>
            );
          })
        }
      </div>
      {paymentConditionsConfirmed &&
        <div style={{fontSize: '16px', marginTop: '12px', fontWeight: 'bold'}}>
          Подтвержденные условия оплаты
        </div>
      }
      {paymentConditionsConfirmed &&
        <div style={{marginTop: '12px'}}>
          {
            paymentConditionsConfirmed.map((condition, i) => {
              if (condition.percent === 0)
                return null;
              return (
                <div key={i} style={{display: 'flex'}}>
                  <div style={{flex: '0 0 60px'}}>{`${condition.percent}%`}</div>
                  {
                    condition.type === 'days'
                    ?
                      <div style={{flex: '0 0 300px'}}>{`через ${condition.val} дней после отгрузки`}</div>
                    :
                    <div style={{flex: '0 0 300px'}}>{condition.val}</div>
                  }
                </div>
              );
            })
          }
        </div>
      }
    </div>
  );
};

export default connect(
  (state, ownProps) => ({ paymentConditions: state.orders[ownProps.orderId].paymentConditions, paymentConditionsConfirmed: state.orders[ownProps.orderId].paymentConditionsConfirmed })
)(PaymentConditionsInfo);



// WEBPACK FOOTER //
// ./src/components/layout/content/prepare-order/payment-conditions-info.js